import React from 'react';
import TimelineStepsContainer from './styles';
import Check from '~/assets/images/check_blue.svg';
import moment from 'moment';

export default function TimelineSteps(props) {
  const steps = [
    {
      title: 'Pedido',
      description: props.stepsInfo.description,
      date: props.stepsInfo.dateBegin,
      active: props.title === 'Pedido' ? true : false,
      purple: props.title === 'Financeiro' ? true : 
      props.title === 'Faturamento' ? true :
      props.title === 'Liberação' ? true :
      props.title === 'Saída' ? true : 
      false
    },
    {
      title: 'Financeiro',
      description: props.stepsInfo.description,
      active: props.title === 'Financeiro' ? true : false,
      purple: props.title === 'Faturamento' ? true :
      props.title === 'Liberação' ? true :
      props.title === 'Saída' ? true : 
      false
    },
    {
      title: 'Faturamento',
      description: props.stepsInfo.description,
      active: props.title === 'Faturamento' ? true : false,
      purple: props.title === 'Liberação' ? true :
      props.title === 'Saída' ? true : 
      false
    },
    {
      title: 'Liberação',
      description: props.stepsInfo.description,
      active: props.title === 'Liberação' ? true : false,
      purple: props.title === 'Saída' ? true : 
      false
    },
    {
      title: 'Saída',
      description: props.stepsInfo.description,
      date: props.stepsInfo.dateEnd,
      active: props.title === 'Saída' ? true : false,
    },
  ];

  return (
    <TimelineStepsContainer>
      <TimelineStepsContainer.Line />
      <TimelineStepsContainer.StepsBox>
        {steps.map(step => (
          <TimelineStepsContainer.Item 
            saida={step.title === "Saída"}
            notPurple={!step.active && !step.purple}
          >
            <TimelineStepsContainer.Step 
              active={step.active} 
              purple={step.purple}
              canceled={props.canceled}
            >
            {
              (props.canceled || !step.purple) ? null : (
                <img
                  src={Check}
                  alt="Check"
                />
              )
            }
            {
              step.title === "Saída" && step.active ? (
                <img
                  src={Check}
                  alt="Check"
                />
              ) : null
            }
            </TimelineStepsContainer.Step>
            <div className="box-text-step">
              <span className={step.active ? 'blue' : 'gray'}>
                {step.title}
              </span>
              <span>
                {step.active ? step.description : null}
                {
                  !step.active && step.title === "Pedido" && step.purple ? 
                  "Pedido recebido" : null
                }
                {
                  !step.active && step.title === "Financeiro" && step.purple ? 
                  "Pedido liberado pelo financeiro" : null
                }
                {
                  !step.active && step.title === "Faturamento" && step.purple && !props.canceled ? 
                  "Aguardando emissão de nota fiscal" : null
                }
                {
                  !step.active && step.title === "Liberação" && step.purple && !props.canceled ? 
                  "Nota fiscal liberada" : null
                }
              </span>
              <span
                className={
                  (step.date && step.purple) || 
                  (step.date && step.active) ? 'normal-color' : 'hide-item'
                }
              >
                {moment(
                    step.date
                  ).format("DD/MM/YYYY")}
                {" "}
                {step.title === "Saída" && step.active && (
                moment(
                  step.date
                ).utc().format("HH:mm")
                )}
              </span>
            </div>
          </TimelineStepsContainer.Item>
        ))}
      </TimelineStepsContainer.StepsBox>
    </TimelineStepsContainer>
  );
};